import PageForm from './PageForm'

const Create = () => {
    return (
        <PageForm
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Page created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create page',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating page...',
                },
            }}
        />
    )
}

export default Create
